import { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const ATTRACTION_ITEMS = [
  {
    num: '01',
    title: '集客戦略の設計（コンサルティング）',
    desc: '現状分析をもとに、最適な集客戦略を設計します。',
    details: [
      'ターゲット顧客の明確化（ペルソナ設計）',
      '市場・競合分析',
      '強み・差別化ポイントの整理',
      '集客導線（ファネル）の構築',
    ],
    note: '「誰に・何を・どうやって届けるか」を明確にします。',
  },
  {
    num: '02',
    title: 'Web集客支援（デジタルマーケティング）',
    desc: 'オンラインでの集客を強化します。',
    details: [
      'SEO対策（検索上位表示対策）',
      'リスティング広告・SNS広告運用',
      'LP（ランディングページ）改善',
      'コンテンツマーケティング（記事作成支援）',
      'SNS運用コンサル（Instagram・Xなど）',
    ],
    note: '「見られる」から「問い合わせにつながる」導線へ改善。',
  },
  {
    num: '03',
    title: '売上導線・成約率の改善',
    desc: '集客後の「売れる仕組み」を構築します。',
    details: [
      'ホームページ・LPの改善提案',
      'CV率（成約率）改善',
      'セールス導線設計',
      '価格・オファー設計',
    ],
    note: 'アクセスはあるのに売れない状態を解決します。',
  },
  {
    num: '04',
    title: 'オフライン集客支援',
    desc: '地域ビジネス・対面ビジネスにも対応します。',
    details: [
      'チラシ・DM戦略設計',
      '店舗集客（Googleマップ対策/MEO）',
      '紹介・口コミ導線の構築',
    ],
    note: '地域密着型ビジネスの集客力を高めます。',
  },
  {
    num: '05',
    title: '継続コンサルティング・運用支援',
    desc: '成果が出るまで伴走します。',
    details: [
      '月次レポート・改善提案',
      '数値分析（アクセス・CV・広告効果）',
      '定期ミーティング',
      '施策のPDCA運用',
    ],
    note: '継続的な改善により安定した集客を実現します。',
  },
];

const SALES_ITEMS = [
  {
    num: '01',
    title: '営業戦略の設計',
    desc: '売れる営業の土台を構築します。',
    details: [
      'ターゲット顧客の再定義',
      '商材・サービスの強み整理',
      '営業プロセスの設計（リード〜成約まで）',
      'KPI設計（アポ率・成約率など）',
    ],
    note: '「なんとなく営業」から「勝てる営業戦略」へ。',
  },
  {
    num: '02',
    title: '営業フローの構築・改善',
    desc: '成果につながる営業導線を整備します。',
    details: [
      'インサイドセールス導入支援',
      'フィールドセールスの最適化',
      '営業トーク・ヒアリング設計',
      '商談フローの標準化',
    ],
    note: '営業のバラつきをなくし、成約率を向上させます。',
  },
  {
    num: '03',
    title: '営業資料・トークスクリプト作成',
    desc: '「売れるための武器」を整えます。',
    details: [
      '提案資料（営業資料）の作成・改善',
      'トークスクリプト設計',
      'クロージングシナリオ構築',
      'よくある反論への対応設計',
    ],
    note: '誰でも一定の成果が出せる状態へ。',
  },
  {
    num: '04',
    title: 'アポ獲得・リードナーチャリング支援',
    desc: '見込み顧客を効率的に育成します。',
    details: [
      'テレアポ・メール営業の改善',
      'アポ獲得率の向上施策',
      '見込み客の育成（ナーチャリング設計）',
      'CRM導入・活用支援',
    ],
    note: '「数頼み営業」から「質重視営業」へ。',
  },
  {
    num: '05',
    title: '営業組織の強化・教育',
    desc: 'チーム全体の営業力を底上げします。',
    details: [
      '営業研修・ロープレ実施',
      'マネジメント体制の構築',
      '営業評価制度の設計',
      '新人教育の仕組み化',
    ],
    note: '強い営業組織を構築します。',
  },
  {
    num: '06',
    title: '数値分析・改善（PDCA運用）',
    desc: 'データに基づく営業改善を実施します。',
    details: [
      '営業KPIの可視化',
      'ボトルネック分析',
      '成約率改善施策',
      '定期レポート・改善提案',
    ],
    note: '感覚ではなく「数字」で伸ばす営業へ。',
  },
];

const FLOW_STEPS = [
  { num: '1', label: 'お問い合わせ・無料相談' },
  { num: '2', label: '現状分析・ヒアリング' },
  { num: '3', label: '戦略提案' },
  { num: '4', label: '実行支援・改善' },
  { num: '5', label: '継続サポート' },
];

const FOR_WHOM_A = [
  '集客が安定せず売上に波がある',
  'ホームページはあるが問い合わせが来ない',
  '広告を出しても成果が出ない',
  '何から手をつければいいかわからない',
  '競争が激しい業界で差別化したい',
];

const FOR_WHOM_S = [
  '営業が属人化していて成果にバラつきがある',
  'アポは取れるが成約につながらない',
  '営業人材の教育がうまくいかない',
  '売上を安定的に伸ばしたい',
  '集客はできているが営業で取りこぼしている',
];

const STRENGTHS_A = [
  '成果重視の実践型コンサルティング',
  '中小企業・個人事業主に特化',
  '資金調達・ファクタリング分野の知見あり',
  '戦略〜実行までワンストップ対応',
];

const STRENGTHS_S = [
  '集客〜営業まで一貫支援が可能',
  '中小企業・個人事業主に特化',
  '実務ベースの現場型コンサル',
  '再現性の高い営業仕組み化',
];

export default function ServicesPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.replace('#', ''));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100);
      }
    }
  }, [location]);

  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Page Hero */}
      <section className="relative pt-32 pb-16 bg-[#1a2332] overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20geometric%20pattern%20with%20dark%20navy%20lines%20and%20grids%2C%20minimal%20corporate%20background%20texture%2C%20professional%20business%20pattern%20design&width=1920&height=400&seq=svc-hero001&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-6 md:px-10">
          <span className="text-xs font-semibold tracking-[3px] text-white/40 uppercase">Services</span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mt-3 mb-4">サービス詳細</h1>
          <p className="text-base text-white/60 max-w-xl">
            集客から営業まで一貫したコンサルティングで、企業の持続的成長をサポートします。
          </p>
          {/* Tab nav */}
          <div className="flex flex-wrap gap-3 mt-8">
            <a href="#attraction" className="px-5 py-2.5 bg-white text-[#1a2332] text-sm font-medium rounded-full whitespace-nowrap cursor-pointer hover:bg-white/90 transition-colors">
              集客コンサルティング
            </a>
            <a href="#sales" className="px-5 py-2.5 border border-white/30 text-white text-sm font-medium rounded-full whitespace-nowrap cursor-pointer hover:bg-white/10 transition-colors">
              営業支援コンサルティング
            </a>
          </div>
        </div>
      </section>

      {/* ── 集客コンサルティング ── */}
      <section id="attraction" className="py-20 md:py-28 bg-white scroll-mt-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start mb-16">
            <div>
              <span className="text-xs font-semibold tracking-[3px] text-gray-400 uppercase">Service 01</span>
              <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mt-3 mb-6">
                集客コンサルティング
              </h2>
              <p className="text-base text-gray-600 leading-relaxed">
                企業・個人事業主様の売上向上を目的とした「集客導線の最適化」を中心に、
                Web・オフラインを組み合わせた総合的な集客支援を行っています。
                単なるアドバイスではなく、成果に直結する実行支援型コンサルティングを提供します。
              </p>
            </div>
            <div className="rounded-2xl overflow-hidden aspect-video">
              <img
                src="https://readdy.ai/api/search-image?query=digital%20marketing%20strategy%20session%20with%20laptop%20showing%20analytics%20dashboard%20and%20SEO%20data%2C%20modern%20office%20desk%20with%20charts%20and%20data%20visualization%2C%20professional%20web%20marketing%20consultant%20working%2C%20clean%20white%20background%20with%20warm%20lighting&width=800&height=450&seq=svc-attract001&orientation=landscape"
                alt="集客コンサルティング"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Items */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {ATTRACTION_ITEMS.map((item) => (
              <div key={item.num} className="bg-[#faf9f7] rounded-xl p-6 md:p-8">
                <div className="flex items-start gap-4 mb-4">
                  <span className="text-3xl font-bold text-[#1a2332]/15 leading-none">{item.num}</span>
                  <div>
                    <h3 className="text-base font-bold text-[#1a2332]">{item.title}</h3>
                    <p className="text-sm text-gray-500 mt-1">{item.desc}</p>
                  </div>
                </div>
                <ul className="space-y-1.5 mb-3 ml-2">
                  {item.details.map((d) => (
                    <li key={d} className="flex items-center gap-2 text-sm text-gray-600">
                      <i className="ri-arrow-right-s-line text-[#1a2332]" />{d}
                    </li>
                  ))}
                </ul>
                <p className="text-xs text-[#1a2332] font-medium bg-[#1a2332]/5 rounded-lg px-3 py-2 mt-3">
                  {item.note}
                </p>
              </div>
            ))}
          </div>

          {/* For whom */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-[#faf9f7] rounded-2xl p-8">
              <h3 className="text-lg font-bold text-[#1a2332] mb-5 flex items-center gap-2">
                <i className="ri-user-heart-line" />このような方におすすめ
              </h3>
              <ul className="space-y-3">
                {FOR_WHOM_A.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-checkbox-circle-line text-[#1a2332] mt-0.5 flex-shrink-0" />{item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-[#1a2332] rounded-2xl p-8">
              <h3 className="text-lg font-bold text-white mb-5 flex items-center gap-2">
                <i className="ri-trophy-line" />当社の強み
              </h3>
              <ul className="space-y-3">
                {STRENGTHS_A.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm text-white/80">
                    <i className="ri-check-double-line text-white mt-0.5 flex-shrink-0" />{item}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Flow */}
          <div className="mt-12">
            <h3 className="text-lg font-bold text-[#1a2332] mb-6">サービスの流れ</h3>
            <div className="flex flex-wrap gap-2">
              {FLOW_STEPS.map((step, i) => (
                <div key={step.num} className="flex items-center gap-2">
                  <div className="flex items-center gap-2 bg-[#faf9f7] rounded-full px-5 py-2.5">
                    <span className="w-6 h-6 flex items-center justify-center rounded-full bg-[#1a2332] text-white text-xs font-bold flex-shrink-0">{step.num}</span>
                    <span className="text-sm font-medium text-[#1a2332] whitespace-nowrap">{step.label}</span>
                  </div>
                  {i < FLOW_STEPS.length - 1 && <i className="ri-arrow-right-line text-gray-300" />}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── 営業支援コンサルティング ── */}
      <section id="sales" className="py-20 md:py-28 bg-[#faf9f7] scroll-mt-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start mb-16">
            <div>
              <span className="text-xs font-semibold tracking-[3px] text-gray-400 uppercase">Service 02</span>
              <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mt-3 mb-6">
                営業支援コンサルティング
              </h2>
              <p className="text-base text-gray-600 leading-relaxed">
                企業様の売上最大化を目的とし、営業戦略の設計から実行・改善までを一貫して支援する
                営業支援コンサルティングを提供しています。
                属人的になりがちな営業活動を「仕組み化」し、再現性のある売上アップを実現します。
              </p>
            </div>
            <div className="rounded-2xl overflow-hidden aspect-video">
              <img
                src="https://readdy.ai/api/search-image?query=sales%20team%20strategy%20meeting%20in%20modern%20office%20with%20whiteboard%20showing%20business%20process%20flowchart%20and%20KPI%20metrics%2C%20professional%20business%20consulting%20session%2C%20Japanese%20business%20people%20collaborating%2C%20clean%20minimalist%20office%20environment&width=800&height=450&seq=svc-sales001&orientation=landscape"
                alt="営業支援コンサルティング"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Items */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {SALES_ITEMS.map((item) => (
              <div key={item.num} className="bg-white rounded-xl p-6 md:p-8">
                <div className="flex items-start gap-4 mb-4">
                  <span className="text-3xl font-bold text-[#1a2332]/15 leading-none">{item.num}</span>
                  <div>
                    <h3 className="text-base font-bold text-[#1a2332]">{item.title}</h3>
                    <p className="text-sm text-gray-500 mt-1">{item.desc}</p>
                  </div>
                </div>
                <ul className="space-y-1.5 mb-3 ml-2">
                  {item.details.map((d) => (
                    <li key={d} className="flex items-center gap-2 text-sm text-gray-600">
                      <i className="ri-arrow-right-s-line text-[#1a2332]" />{d}
                    </li>
                  ))}
                </ul>
                <p className="text-xs text-[#1a2332] font-medium bg-[#1a2332]/5 rounded-lg px-3 py-2 mt-3">
                  {item.note}
                </p>
              </div>
            ))}
          </div>

          {/* For whom */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-8">
              <h3 className="text-lg font-bold text-[#1a2332] mb-5 flex items-center gap-2">
                <i className="ri-user-heart-line" />このような方におすすめ
              </h3>
              <ul className="space-y-3">
                {FOR_WHOM_S.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-checkbox-circle-line text-[#1a2332] mt-0.5 flex-shrink-0" />{item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-[#1a2332] rounded-2xl p-8">
              <h3 className="text-lg font-bold text-white mb-5 flex items-center gap-2">
                <i className="ri-trophy-line" />当社の強み
              </h3>
              <ul className="space-y-3">
                {STRENGTHS_S.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm text-white/80">
                    <i className="ri-check-double-line text-white mt-0.5 flex-shrink-0" />{item}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Integration banner */}
          <div className="mt-12 bg-[#1a2332] rounded-2xl p-8 md:p-10 text-center">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-3">
              集客×営業の一体支援で売上最大化
            </h3>
            <p className="text-white/70 text-sm leading-relaxed mb-6 max-w-2xl mx-auto">
              当社では、集客コンサルティングと営業支援を組み合わせることで、
              「集めて終わり」ではなく「売上につながる仕組み」を構築します。
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-white text-[#1a2332] font-semibold rounded-full hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer"
            >
              お問合せ <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
